import React from "react";

export default function GesubsidieerdeClubsOverinstIcon() {
    return (<svg version="1.1" id="Laag_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="1.5rem" y="1.5rem" height="1.8rem"
    viewBox="0 0 425.2 425.2" style={{enableBackground:'new 0 0 425.2 425.2;'}} xmlSpace="preserve">
<circle fill={"#F7A93C"} cx="217.66" cy="211.74" r="182.19"/>
<g>
   <path fill={"#AA5F1E"} d="M315.35,142.12c-18.52-22.68-49.14-38.56-86.94-38.56c-47.25,0-85.05,31-96.77,71.82h168.21l-11.34,23.81
       H126.34c-0.38,4.91-0.76,8.69-0.76,12.47c0,3.78,0.38,7.18,0.76,11.34h151.2l-11.34,23.81H131.63
       c13.61,44.6,51.41,72.58,100.55,72.58c34.02,0,64.26-14.74,83.16-37.42v32.13c-18.9,15.12-51.03,29.11-85.05,29.11
       c-60.48,0-111.51-36.67-125.5-96.39H62.08l11.34-23.81h26.84c-0.38-4.91-0.38-8.32-0.38-11.72c0-3.78,0-7.18,0.38-12.1H62.08
       l11.34-23.81h31.37c13.99-59.72,65.02-95.64,127.39-95.64c35.91,0,73.71,15.12,94.12,39.31L315.35,142.12z"/>
</g>
</svg>
    );
}